export default __webpack_public_path__ + "static/screenshot_7d-7adbe474fd4f82ac93290c04aad3839b.png";